export const SET_IM_TEST_FORMDATA = 'SET_IM_TEST_FORMDATA';
export const SET_IM_TEST_ERROR = 'SET_IM_TEST_ERROR';
export const NEXT_BACK_STEP_IM_TEST = 'NEXT_BACK_STEP_IM_TEST';
export const SET_IM_TEST_STEP = 'SET_IM_TEST_STEP';
export const SET_UPLOAD_DATA_SET = 'SET_UPLOAD_DATA_SET';

export const SHOW_HIDE_PREVIEW_IM_TEST = 'SHOW_HIDE_PREVIEW_IM_TEST';
